import AntdTabs from "antd/es/tabs";

export type TabsProps = React.ComponentProps<typeof AntdTabs>;

const Tabs = AntdTabs;

export { Tabs };
